import { createBrowserRouter } from 'react-router';
import AppLayout from '@/layouts/AppLayout';
import LoginPage from '@/pages/LoginPage';
import { requireAuth } from '@/auth/session';

// The pages behind the login are loaded on first visit, each in its own chunk,
// so the login screen does not download the date pickers, the QR decoder and
// every dialog up front. The layout and the login page stay in the entry chunk.
export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    id: 'protected',
    path: '/',
    element: <AppLayout />,
    loader: requireAuth,
    children: [
      { index: true, lazy: async () => ({ Component: (await import('@/pages/DashboardPage')).default }) },
      { path: 'companies', lazy: async () => ({ Component: (await import('@/pages/CompaniesPage')).default }) },
      { path: 'companies/new', lazy: async () => ({ Component: (await import('@/pages/CreateCompanyPage')).default }) },
      { path: 'company-taxes', lazy: async () => ({ Component: (await import('@/pages/CompanyTaxesPage')).CompanyTaxesPage }) },
      { path: 'company-information', lazy: async () => ({ Component: (await import('@/pages/CompanyInformationPage')).default }) },
      { path: 'users', lazy: async () => ({ Component: (await import('@/pages/RootUsersPage')).default }) },
    ],
  },
]);
